import { ApiError } from '../errors/api-error.js';
import { withRetry } from '../utils/retry.js';

export class BigdesMeasureService {
    constructor(api, config = {}) {
        this.api = api;
        this.config = config;
    }

    async getAll(params = {}) {
        try {
            const response = await withRetry(
                () => this.api.getAll(params),
                { maxRetries: 2 },
            );

            return {
                success: true,
                data: response.data,
                pagination: response.pagination || {},
                uniqueValues: response.uniqueValues || {},
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch bigdes-measure list');
        }
    }

    async getById(id) {
        try {
            const response = await withRetry(
                () => this.api.getById(id),
                { maxRetries: 2 },
            );

            return {
                success: true,
                data: response.data,
            };
        } catch (error) {
            throw this._handleError(error, 'Failed to fetch bigdes-measure');
        }
    }

    _handleError(error, fallbackMessage) {
        if (error instanceof ApiError) return error;
        return new ApiError(fallbackMessage, error?.response?.status || 500, error?.response?.data);
    }
}
